import FastMarquee from 'react-fast-marquee';

export default function Marquee() {
  return (
    <section
      className="relative py-8 lg:py-10 border-y border-[#c2a978]/15 bg-[#050505] overflow-hidden"
      data-testid="marquee-section"
    >
      <FastMarquee speed={30} gradient={false} pauseOnHover={false}>
        <div className="flex items-center gap-14 pr-14">
          <span
            className="font-sans text-[6vw] lg:text-[4vw] leading-none whitespace-nowrap uppercase tracking-[0.08em] font-light"
            style={{
              WebkitTextStroke: '1px #c2a978',
              color: 'transparent',
            }}
          >
            Scorpion Funding
          </span>
          <span className="text-[#c2a978] text-[4vw] lg:text-[3vw] font-light">
            ✦
          </span>
          <span className="font-sans text-[6vw] lg:text-[4vw] text-[#f5f5f0] leading-none whitespace-nowrap uppercase tracking-[0.08em] font-light">
            Capital · Precision · Discretion
          </span>
          <span className="text-[#c2a978] text-[4vw] lg:text-[3vw] font-light">
            ✦
          </span>
        </div>
      </FastMarquee>
    </section>
  );
}
